export const FEDOPS_APP_NAME = 'communities-blog-custom-feed-widget';
